__webpack_require__.p = "https://cdn.n-tv.de/sport/0.67.2/_next/";